import { type FC, type PropsWithChildren } from 'react';
import { Controller, type Control } from 'react-hook-form';
import { FormControl, FormHelperText, Grid, TextField } from '@mui/material';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';
import { getFormErrorAttributes } from '#apps/client-web/app/helpers/react-hook-form';

import {
  SubFormDialog,
  type SubFormDialogProps,
} from '#packages/web/layouts/dialog/templates/sub-form';

export type OtherFormDialogProps = Pick<
  SubFormDialogProps,
  'onClose' | 'open'
> & {
  control: Control<EditAuditFormBackgroundData>;
};

export const OtherFormDialog: FC<PropsWithChildren<OtherFormDialogProps>> = ({
  open,

  control,

  onClose,
}) => (
  <SubFormDialog title="Other" open={open} onClose={onClose}>
    <Grid container spacing={2}>
      <Controller
        control={control}
        name="general.heatingHotWater"
        render={({ field, fieldState }) => (
          <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
            <TextField
              {...field}
              label="Heating Hot Water (ft)"
              type="number"
              variant="outlined"
              {...getFormErrorAttributes(fieldState.error)}
            />
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
          </FormControl>
        )}
      />
      <Controller
        control={control}
        name="general.domesticHotWater"
        render={({ field, fieldState }) => (
          <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
            <TextField
              {...field}
              label="Domestic Hot Water (ft)"
              type="number"
              variant="outlined"
              {...getFormErrorAttributes(fieldState.error)}
            />
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
          </FormControl>
        )}
      />
      <Controller
        control={control}
        name="general.renovations"
        rules={{ maxLength: 120 }}
        render={({ field, fieldState }) => (
          <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
            <TextField
              {...field}
              label="Sections added, renovations, etc."
              type="text"
              variant="outlined"
              {...getFormErrorAttributes(fieldState.error)}
            />
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
          </FormControl>
        )}
      />
      <Controller
        control={control}
        name="general.operationHours"
        render={({ field, fieldState }) => (
          <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
            <TextField
              {...field}
              label="Operation hours"
              type="number"
              variant="outlined"
              {...getFormErrorAttributes(fieldState.error)}
            />
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
          </FormControl>
        )}
      />
      <Controller
        control={control}
        name="general.operationHoursDescription"
        rules={{ maxLength: 120 }}
        render={({ field, fieldState }) => (
          <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
            <TextField
              {...field}
              label="Operation hours description"
              type="text"
              variant="outlined"
              multiline
              rows={3}
              {...getFormErrorAttributes(fieldState.error)}
            />
            <FormHelperText>{fieldState.error?.message}</FormHelperText>
          </FormControl>
        )}
      />
    </Grid>
  </SubFormDialog>
);
